export default __webpack_public_path__ + "static/media/edit-btn.57f6e3cd.svg";